import React, { useEffect, useRef, useState } from "react";
import { toast } from "react-toastify";
import axios from "axios";

import { ProductFormContainer } from "../../../../styled/setting";

import useUploadFiles from "../../../../../../../../hooks/useUploadFiles";

import ProductForm from "./productForm";
import Info from "../../../common/info";

const EditProduct = ({
  product,
  setProduct,
  closeForm,
  categoriesObj,
  openModal,
  closeModal,
  selectCompany,
  getProducts,
  clickImages,
  setIsDetail,
  options,
  setOptions,
  initialOptions = [],
  toggleModal,
  changeSlide,
  getMenuGroup,
}) => {
  const { uploadFiles, uploadEmbedded } = useUploadFiles();

  const getOptionsId = (arr) => arr.map((item) => item.id);

  const isSameOrder = (a, b) => {
    const aIds = getOptionsId(a);
    const bIds = getOptionsId(b);
    return JSON.stringify(aIds) === JSON.stringify(bIds);
  };

  // 순서 체크
  // useEffect(() => {
  //   if (isSameItems(options, initialOptions) && !isSameOrder(options, initialOptions)) {
  //     console.log("id 기준으로 순서만 바뀜");
  //   }
  // }, [options, initialOptions]);

  // 파일 업로드

  const handleUpload = async () => {
    try {
      const media = product.media || [];

      const alreadyUploaded = media.filter((item) => !item.file);
      const fileOnly = media.filter((item) => item.file).map((item) => item.file);

      const uploadedFiles = fileOnly.length ? await uploadFiles(fileOnly) : [];

      const updatedDesc = await uploadEmbedded(product.description);

      const finalMedia = [
        ...alreadyUploaded.map((item) => ({ path: item.path })),
        ...uploadedFiles.map((item) => ({ path: item.fileName })),
      ];

      return { media: finalMedia, description: updatedDesc };
    } catch (error) {
      console.error("파일 업로드 중 오류 발생:", error);
      return { media: [], description: product.description };
    }
  };

  const handleEdit = async () => {
    const uploadedData = await handleUpload();
    updateProduct(uploadedData.media, uploadedData.description);
  };

  const handleSave = () => {
    if (!validationCheck()) return;

    openModal({
      type: "confirmation",
      title: "상품 수정",
      message: ["변경한 상품을 저장하시겠습니까?"],
      handleConfirm: handleEdit,
    });
  };

  // 유효성 체크
  const validationCheck = () => {
    if (!product.name) {
      toast.error("상품명을 입력해주세요.");
      return false;
    }

    if (product.price === null || product.price === undefined || product.price === "") {
      toast.error("가격을 입력해주세요.");
      return false;
    }

    // if (!product.categoryId) {
    //   toast.error("카테고리를 선택해주세요.");
    //   return false;
    // }

    return true;
  };

  // 상품 정보 수정
  const updateProduct = async (files = [], description) => {
    try {
      const url = "/erp/vendorProducts/update";
      const body = {
        id: product?.id,
        input: {
          cmpnyNo: selectCompany?.value,
          name: product?.name,
          description: description || " ",
          shortDescription: product?.shortDescription || "",
          brand: product?.brand,
          specifications: product?.specifications,
          categoryId: product?.categoryId,
          media: files.map((file) => file.path),
          quantity: toNumber(product?.quantity),
          price: product?.price ? toNumber(product?.price) : 0,
          useDisplay: product?.useDisplay,
          status: product?.status,
          optionGroupIds: options.map((opt) => opt.id),
          tags: product.tags,
        },
      };

      const res = await axios.post(url, body);

      if (res.status === 200) {
        // const sameItems = isSameItems(options, initialOptions);
        const sameOrder = isSameOrder(options, initialOptions);

        if (!sameOrder) {
          await updateOptionOrder();
        }

        toast.success("상품이 변경되었습니다.");
        await getMenuGroup();
        await getProducts();
        closeForm();
      }
    } catch (error) {
      console.error(error);
    } finally {
      closeModal();
    }
  };

  // 옵션 순서 변경
  const updateOptionOrder = async () => {
    try {
      const url = "/erp/vendorProduct/optionOrder";
      const body = {
        input: {
          vendorProductId: product?.id,
          optionGroupOrders: options.map((opt, idx) => ({
            optionGroupId: opt.id,
            sortOrder: idx,
          })),
        },
      };
      await axios.post(url, body);
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <ProductFormContainer>
      <Info
        message="상품 수정"
        actions={[
          {
            label: "취소",
            func: () =>
              openModal({
                type: "confirmation",
                title: "나가기",
                message: ["작업 중인 내용이 사라질 수 있습니다.", "저장하지 않고 나가시겠습니까?"],
                handleConfirm: closeForm,
              }),
            key: "cancel",
          },
          { label: "저장", func: handleSave, key: "add" },
        ]}
      />
      <ProductForm
        product={product}
        setProduct={setProduct}
        categoriesObj={categoriesObj}
        setIsDetail={setIsDetail}
        clickImages={clickImages}
        selectCompany={selectCompany}
        options={options}
        setOptions={setOptions}
        toggleModal={toggleModal}
        changeSlide={changeSlide}
      />
    </ProductFormContainer>
  );
};

export default EditProduct;
